import "./App.css";
import LoginForm from "./components/authentication/LoginForm";
import MainPage from "./components/business/homePageContainers/rightContainer/MainPage";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import SessionManager from "./components/websession/SessionManager";
import { AuthProvider } from "./context/AuthProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/ui-kit.css";
import ForgotPassword from "./components/authentication/ForgotPassword";
import ResetPassword from "./components/authentication/ResetPassword";
import AdminPage from "./components/management/adminPage/AdminPage";
import BusinessRegistrasion from "./components/authentication/BusinessRegistrasion";
import TermsPrivacy from "./legal/TermsPrivacy";
import EmailVerification from "./components/authentication/EmailVerification";
import CompleteInvite from "./components/authentication/CompleteInvite";

const queryClient = new QueryClient();

function AppContent() {
  return (
    <div className="App app-layout">
      <SessionManager />
      <div className="app-main">
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/business-register" element={<BusinessRegistrasion />} />
          <Route path="/privacy-policy" element={<TermsPrivacy />} />
          <Route path="/verify-email" element={<EmailVerification />} />
          <Route path="/invite" element={<CompleteInvite />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/home/*" element={<MainPage />} />
          </Route>
          <Route element={<ProtectedRoute roles={['GLOBAL_ADMIN']} />}>
            <Route path="/admin/*" element={<AdminPage />} />
          </Route>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        style={{
          top: "calc(var(--app-safe-area-top) + 12px)",
          left: "calc(var(--app-safe-area-left) + 20px)",
          right: "calc(var(--app-safe-area-right) + 20px)",
          transform: "none",
          width: "auto",
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </QueryClientProvider>
    </Router>
  );
}
